/** Curated viewpoints / trail stops (scene coordinates, heading in degrees from north, pitch in degrees). */
export interface Place {
  id: string;
  name: string;
  group: 'Rim' | 'Navajo Loop' | 'Aerial';
  x: number;
  z: number;
  heading: number;
  pitch: number;
  mode: 'walk' | 'fly';
  height?: number; // for fly mode, meters above ground
  note: string;
}

export const PLACES: Place[] = [
  { id: 'sunset', name: 'Sunset Point', group: 'Rim', x: 9, z: 24, heading: 98, pitch: -9, mode: 'walk', note: 'Overlook above Thor’s Hammer, 8,000 ft' },
  { id: 'sunrise', name: 'Sunrise Point', group: 'Rim', x: 283, z: -598, heading: 140, pitch: -10, mode: 'walk', note: 'Queen’s Garden below' },
  { id: 'inspiration', name: 'Inspiration Point', group: 'Rim', x: -266, z: 1019, heading: 60, pitch: -12, mode: 'walk', note: 'Silent City from above' },
  { id: 'bryce', name: 'Bryce Point', group: 'Rim', x: 742, z: 1897, heading: 345, pitch: -8, mode: 'walk', note: 'The whole amphitheater' },
  { id: 'trailhead', name: 'Navajo Loop trailhead', group: 'Navajo Loop', x: -2, z: 13, heading: 120, pitch: -12, mode: 'walk', note: 'Start of the 1.3 mi loop' },
  { id: 'thor', name: 'Thor’s Hammer', group: 'Navajo Loop', x: 82, z: -12, heading: 115, pitch: 6, mode: 'walk', note: 'Two Bridges side switchbacks' },
  { id: 'wallstreet', name: 'Wall Street', group: 'Navajo Loop', x: -14, z: 222, heading: 170, pitch: 20, mode: 'walk', note: 'Slot canyon with Douglas firs' },
  { id: 'twobridges', name: 'Two Bridges', group: 'Navajo Loop', x: 192, z: 190, heading: 56, pitch: 34, mode: 'walk', note: 'Twin natural bridges' },
  { id: 'bottom', name: 'Loop junction', group: 'Navajo Loop', x: 348, z: 500, heading: 300, pitch: 4, mode: 'walk', note: 'Queen’s Garden & Peekaboo junction' },
  { id: 'queen', name: 'Queen Victoria', group: 'Navajo Loop', x: 412, z: -350, heading: 95, pitch: 8, mode: 'walk', note: 'Queen’s Garden hoodoo' },
  { id: 'aerial', name: 'Over the amphitheater', group: 'Aerial', x: -350, z: 260, heading: 80, pitch: -16, mode: 'fly', height: 260, note: 'Fly-over of Bryce Amphitheater' },
  { id: 'high', name: 'High above the plateau', group: 'Aerial', x: -2600, z: 1800, heading: 55, pitch: -14, mode: 'fly', height: 1100, note: 'Paunsaugunt Plateau & Pink Cliffs' },
];
